// extracted by mini-css-extract-plugin
module.exports =  {"root":"exdLHYkoJGq8hQYcfqZg","flavors":"QaHQ9Y40jRfXdLLfPJGi","mode":"mfqftUwkB5fvwN1GQfgI"};